import { Factory } from './factory';
import { Chapter } from '../chapter';

export class ChapterFactory implements Factory<Chapter> {

    buildFromFactory(): Chapter {
        return undefined;
    }

    buildFromObject(jsonObject: any): Chapter {
        const chapter = new Chapter();
        chapter.id = jsonObject.id;
        chapter.parentChapterId = jsonObject.parentChapterId;
        chapter.title = jsonObject.title;
        chapter.index = jsonObject.index;
        chapter.sortOrder = jsonObject.sortOrder;
        chapter.orderName = jsonObject.orderName;

        chapter.subChapters = [];
        jsonObject.subChapters.forEach(element => {
            const subChapter = this.buildFromObject(element);
            chapter.subChapters.push(subChapter);
        });

        return chapter;
    }
}
